import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "googleCalendar",
  "name": "Google Calendar",
  "category": "integrations",
  "description": "Create and manage events in Google Calendar",
  "icon": "siGooglecalendar",
  "iconType": "simple-icon",
  "color": "blue",
  "version": "1.2.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Google Calendar",
    "color": "#4285f4"
  },
  "credentials": [
    {
      "name": "googleCalendarOAuth2",
      "required": true,
      "displayName": "Google Calendar OAuth2"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "google",
    "calendar",
    "events",
    "schedule",
    "meetings"
  ],
  "comingSoon": true
};

export default definition;
